<template>
  <div class="platforms">
    <h1>这个组件可以保留，用来调试接口访问，后期有修改我还是更新这个文件！</h1>
    <h2>在线调试 http://api-project.itheima.net/graphql</h2>
    <!-- 分类-平台 -->
    <ApolloQuery :query="require('../graphql/Platforms.gql')">
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Result -->
        <div class="list" v-if="data">
          <!--  -->
          分类-平台
          <br />
          {{ data }}
          <br />
          <ul>
            <li v-for="item in data.pPlatforms" :key="item.id">id:{{item.id}} - name:{{item.name}}</li>
          </ul>
        </div>
      </template>
    </ApolloQuery>

    <!-- 分类-学科 -->
    <ApolloQuery :query="require('../graphql/Categories.gql')">
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Result -->
        <div class="list" v-if="data">
          <!--  -->
          分类-学科
          <br />
          {{ data }}
          <br />
          <ul>
            <li v-for="item in data.pCategories" :key="item.id">id:{{item.id}} - name:{{item.name}}</li>
          </ul>
        </div>
      </template>
    </ApolloQuery>

    <!-- 分类-行业 -->
    <ApolloQuery :query="require('../graphql/Trades.gql')">
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Result -->
        <div class="list" v-if="data">
          <!--  -->
          分类-行业
          <br />
          {{ data }}
          <br />
          <ul>
            <li v-for="item in data.pTrades" :key="item.id">id:{{item.id}} - name:{{item.name}}</li>
          </ul>
        </div>
      </template>
    </ApolloQuery>

    <!-- 项目列表-按学科查询 -->
    <ApolloQuery
      :query="require('../graphql/Contents.gql')"
      :variables="{subjectID: 1, isPublish: true}"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Result -->
        <div class="list" v-if="data">
          <!--  -->
          项目列表-按学科查询
          <br />
          {{ data }}
          <br />
          <ul>
            <li
              v-for="item in data.pContents"
              :key="item.id"
            >id:{{item.id}} - name:{{item.name}} - url:{{item.logoImage.url}} - 行业:{{item.trade.name}}</li>
          </ul>
        </div>
      </template>
    </ApolloQuery>

    <!-- 项目详情-按id查询 -->
    <ApolloQuery :query="require('../graphql/ContentDetail.gql')" :variables="{id: 1}">
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Result -->
        <div class="list" v-if="data">
          <!--  -->
          项目详情-按id查询
          <br />
          {{ data }}
          <br />
          <ul>
            <li>id:{{data.pContent.id}}</li>
            <li>项目名称:{{data.pContent.name}}</li>
            <li>行业:{{data.pContent.trade.name}}</li>
            <li>平台:{{data.pContent.platforms}}</li>
            <li>最后更新:{{data.pContent.lastUpdate}}</li>
            <li>更新日志:{{data.pContent.gitlabLogs}}</li>
            <li>简介:{{data.pContent.description}}</li>
            <li>视频:{{data.pContent.pVideoUrl}}</li>
            <li>轮播图:{{data.pContent.pAdImages}}</li>
            <li>
              演示地址:
              {{data.pContent.demoLink1}}
              {{data.pContent.demoLink2}}
              {{data.pContent.demoLink3}}
              {{data.pContent.demoLink4}}
              {{data.pContent.demoLink5}}
              {{data.pContent.demoLink6}}
            </li>
            <li>
              基本信息:
              {{data.pContent.baseInfoTitle1}}
              {{data.pContent.baseInfoDesc1}}
              {{data.pContent.baseInfoTitle2}}
              {{data.pContent.baseInfoDesc2}}
              {{data.pContent.baseInfoTitle3}}
              {{data.pContent.baseInfoDesc3}}
              {{data.pContent.baseInfoTitle4}}
              {{data.pContent.baseInfoDesc4}}
              {{data.pContent.baseInfoTitle5}}
              {{data.pContent.baseInfoDesc5}}
              {{data.pContent.baseInfoTitle6}}
              {{data.pContent.baseInfoDesc6}}
              {{data.pContent.baseInfoTitle7}}
              {{data.pContent.baseInfoDesc7}}
              {{data.pContent.baseInfoTitle8}}
              {{data.pContent.baseInfoDesc8}}
            </li>
            <li>技术亮点:{{data.pContent.technicalHighlights}}</li>
            <li>技术解决方案:{{data.pContent.technologySolution}}</li>
            <li>功能架构图:{{data.pContent.functionalArchitectureDiagram.url}}</li>
            <li>技术架构图:{{data.pContent.technicalArchitectureDiagram.url}}</li>
            <li>
              课程大纲:
              {{data.pContent.courseOutlineTitle1}}
              {{data.pContent.courseOutlineDesc1}}
              {{data.pContent.courseOutlineTitle2}}
              {{data.pContent.courseOutlineDesc2}}
              {{data.pContent.courseOutlineTitle3}}
              {{data.pContent.courseOutlineDesc3}}
              {{data.pContent.courseOutlineTitle4}}
              {{data.pContent.courseOutlineDesc4}}
              {{data.pContent.courseOutlineTitle5}}
              {{data.pContent.courseOutlineDesc5}}
              {{data.pContent.courseOutlineTitle6}}
              {{data.pContent.courseOutlineDesc6}}
              {{data.pContent.courseOutlineTitle7}}
              {{data.pContent.courseOutlineDesc7}}
              {{data.pContent.courseOutlineTitle8}}
              {{data.pContent.courseOutlineDesc8}}
              {{data.pContent.courseOutlineTitle9}}
              {{data.pContent.courseOutlineDesc9}}
              {{data.pContent.courseOutlineTitle10}}
              {{data.pContent.courseOutlineDesc10}}
            </li>
          </ul>
        </div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
export default {
  name: 'Platforms',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.platforms {
  .list {
    background-color: antiquewhite;
  }
}
</style>
